export const ReportServiceImplFactory = ({
  reportRepository,
}: {
  reportRepository: IReportRepository;
}) => {
  const getDailyReportList: IGetDailyReportList = async ({
    clinicId,
    floorIds,
    start,
    end,
    page,
    page_size: pageSize,
  }) => {
    try {
      const payload: IGetDailyReportListApiPayload = {
        clinic_id: clinicId,
        floor_ids: floorIds,
        page_size: pageSize,
        page,
      };
      if (start && end) {
        payload.start_date = start;
        payload.end_date = end;
      }
      const response = await reportRepository.getDailyReportList(payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getDailyReport: IGetDailyReport = async ({
    clinicId,
    dailyReportId,
  }) => {
    try {
      const payload: IGetDailyReportApiPayload = {
        clinic_id: clinicId,
        daily_report_id: dailyReportId,
      };
      const response = await reportRepository.getDailyReport(payload);

      return {
        success: true,
        data: {
          data: response.data
            ? Object.entries(response.data).map(([_, value]) => ({
                ...value,
              }))
            : [],
        },
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const addReadDailyReport: IReadDailyReport = async ({
    clinicId,
    dailyReportId,
    isRead,
  }) => {
    try {
      const payload: IReadDailyReportApiPayload = {
        clinic_id: clinicId,
        daily_report_id: dailyReportId,
        is_read: isRead,
      };
      const response = await reportRepository.addReadDailyReport(payload);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getRiskReport: IGetRiskReport = async (payload) => {
    try {
      const response = await reportRepository.getRiskReportAPI(payload);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getReadmitRadar: IGetReadmitRadar = async (payload) => {
    try {
      const response = await reportRepository.getReadmitRadarAPI(payload);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getRiskReportPreference: IGetRiskReportPreference = async (payload) => {
    try {
      const response = await reportRepository.getRiskReportPreferenceAPI(
        payload
      );
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getRiskReportList: IGetRiskReportListService = async (payload) => {
    try {
      const response = await reportRepository.getRiskReportListAPI(payload);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getReadmitRadarMostCritical: IGetReadmitRadar = async (payload) => {
    try {
      const response = await reportRepository.getReadmitRadarMostCriticalAPI(
        payload
      );
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const putAckRiskReportService: IPutAckRiskReportService = async (payload) => {
    try {
      const response = await reportRepository.putAckRiskReport(payload);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  return {
    getDailyReportList,
    getDailyReport,
    addReadDailyReport,
    getRiskReport,
    getReadmitRadar,
    getRiskReportPreference,
    getRiskReportList,
    getReadmitRadarMostCritical,
    putAckRiskReportService,
  };
};
